import { Foundation } from 'foundation-sites/js/foundation.core';
import { Reveal } from 'foundation-sites/js/foundation.reveal';

export class HeroMain {
  constructor (target) {
    this.section = target;
    this.backgroundVideo = this.section.querySelector('.bg-video');
    this.modalVideo = this.section.querySelector('.modal-video');

    this.$modalEl = $(this.section).find('.hero-main-video-modal');
    this.openModalBtn = this.section.querySelector('.open-modal');
    this.closeModalBtn = this.section.querySelector('.close-button');

    this.youtubeModal = this.section.querySelector('.youtube-video-modal');

    this.modal = null;
  }

  async init () {
    if (!this.section || CMS.editMode) {
      return;
    }

    await this.initFoundationReveal();
    this.bindModalEvents();
    this.loading(false);
  }

  async initFoundationReveal() {
    Foundation.plugin(Reveal, 'Reveal');

    if (this.$modalEl.data('zfPlugin')) {
      return;
    }

    this.modal = new Foundation.Reveal(this.$modalEl);

    if (this.youtubeModal && !$(this.youtubeModal).data('zfPlugin')) {
      await new Foundation.Reveal($(this.youtubeModal));
    }
  }

  bindModalEvents() {
    if (this.youtubeModal) {
      this.bindYouTubeModalEvents();
    } else {
      this.bindDefaultModalEvents();
    }
  }

  bindYouTubeModalEvents() {
    $(document).on('closed.zf.reveal', '.youtube-video-modal', event => {
      const videoPlaceholder = $(event.target).find('.js-video-frame');

      if (videoPlaceholder.length) {
        videoPlaceholder.html(''); // Usunięcie iframe po zamknięciu
      }
    });

    $(document).on('open.zf.reveal', '.youtube-video-modal', event => {
      const videoPlaceholder = $(event.target).find('.js-video-frame');

      if (!videoPlaceholder.length) {
        return;
      }

      const id = videoPlaceholder.data('id');
      const playlistId = videoPlaceholder.data('playlist');
      const iframe = document.createElement('iframe');

      if (playlistId) {
        iframe.src = playlistId;
      } else {
        iframe.src = `https://www.youtube.com/embed/${id}?enablejsapi=1&autoplay=1`;
      }
      iframe.frameborder = '0';
      iframe.allow =
        'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';
      iframe.allowFullscreen = true;

      videoPlaceholder.html(iframe);
    });

    this.openModalBtn?.addEventListener('click', event => {
      event.preventDefault();

      this.bindModalEvents();

      this.modal.open();
    })

    this.closeModalBtn?.addEventListener('click', () => {
      this.modal.close();

      if (this.backgroundVideo && this.backgroundVideo.paused) {
        this.backgroundVideo.play();
      }
    });
  }

  bindDefaultModalEvents() {
    this.openModalBtn?.addEventListener('click', event => {
      event.preventDefault();

      if (this.backgroundVideo && !this.backgroundVideo.paused) {
        this.backgroundVideo.pause();
      }

      this.modal.open();

      if (this.modalVideo) {
        this.modalVideo.play();
      }
    });

    this.closeModalBtn?.addEventListener('click', () => {
      if (this.modalVideo) {
        this.modalVideo.pause();
      }

      this.modal.close();

      if (this.backgroundVideo && this.backgroundVideo.paused) {
        this.backgroundVideo.play();
      }
    });

    this.$modalEl.on('closed.zf.reveal', () => {
      if (this.backgroundVideo && this.backgroundVideo.paused) {
        this.backgroundVideo.play();
      }

      if (this.modalVideo) {
        this.modalVideo.pause();
      }
    });
  }

  loading(isLoading = true) {
    this.section.classList.toggle('loading', isLoading);
  }
}
